<template>
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
		<circle cx="12" cy="12" r="10"/>
		<path d="M12 16v-4M12 8h0"/>
	</svg>
</template>